import React, { useState } from "react";
import {
  CardWrapper,
  DeleteIcon,
  ThreeDotsContainer,
  UpdateIcon,
} from "./style";
import { Carousel, Tooltip } from "antd";
import { FiMoreVertical } from "react-icons/fi";
import { FiEdit } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { LuCalendarDays } from "react-icons/lu";

import { FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa";

export default ({ data, handleUpdate, handleDelete }) => {
  const [threeDotsClicked, setThreeDotsClicked] = useState(false);
  const nextArrow = (
    <FaChevronRight className="custom-arrow custom-arrow-right" />
  );
  const prevArrow = (
    <FaChevronLeft className="custom-arrow custom-arrow-left" />
  );
  return (
    <CardWrapper>
      {threeDotsClicked && (
        <ThreeDotsContainer
          onMouseOver={() => setThreeDotsClicked(true)}
          onMouseOut={() => setThreeDotsClicked(false)}
        >
          <UpdateIcon onClick={() => handleUpdate(data)}>
            <FiEdit /> Tahrirlash
          </UpdateIcon>
          <DeleteIcon
            onClick={() => {
              handleDelete(data?.id);
            }}
          >
            <FiTrash2 /> O‘chirish
          </DeleteIcon>
        </ThreeDotsContainer>
      )}

      <div className="card-header">
        <div className="truncate-text">{data.title}</div>
        <button
          className="dotsWrap"
          onClick={() =>
            threeDotsClicked
              ? setThreeDotsClicked(false)
              : setThreeDotsClicked(true)
          }
        >
          <FiMoreVertical viewBox="0 2 5 24" className="three-dots" />
        </button>
      </div>
      <div className="image-wrapper">
        <Carousel
          arrows
          prevArrow={prevArrow}
          nextArrow={nextArrow}
          dots={false}
          infinite={true}
        >
          {data?.img?.map((item, i) => (
            <div key={i}>
              <img
                className="picture"
                crossOrigin="anonymous"
                src={item}
                alt=""
              />
            </div>
          ))}
        </Carousel>
      </div>

      <div className="card-title">
        <Tooltip
          title={data.desc} ////kerak bolsa ishlatiladi
          placement="bottom"
          overlayStyle={{
            backgroundColor: "#fff",
          }}
        >
          {data.desc}
        </Tooltip>
      </div>

      <div className="card-date-and-views">
        <div className="innner-url-and-view">{data.url}</div>
        <div className="innner-date-and-view">
          <LuCalendarDays size={14} /> {data.date}
        </div>
      </div>
    </CardWrapper>
  );
};
